import type { FaireProductEntity } from "../../entity_types/product";

export const p_a8lhb1wu: FaireProductEntity = {
  token: "p_a8lhb1wu",
  type: "product",
  name: "Thank You Card with Chocolate Inside - Thanks, You're a Gem!",
  brandToken: "b_bvyg6e7p",
  brandName: "Sweeter Cards Chocolate Bar + Greeting Card in ONE!",
  imageUrl:
    "https://cdn.faire.com/fastly/9e03538f98db9a850968fdae740f46cf0b41d7534cd6ec5d75432bffca634550.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/dd62ba7630943e5a2d71b0afdc1841b61901ea8139a45d90bff4d1f7e12fb5af/1561999175.jpg",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/3d2e871e07ceef5644aa3568c382a6b3a7439bd28c4a24764a979108c9f7488c/1552672246.jpg",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/ecd23af720dcfc9049e43827137b0ec3c9873030dfff8e6b7375f36596af7945/1545538809.png",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/b3da3759d82b243d0bc7f702095d9b1659bee1576a3fcc8b3e624dd78159f614/1552672212.jpg",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/79f6872cadc99cf1d650b5c37b67d2f2531c0adea7ae12612ff148c5612023c8/1561999939.jpg",
  ],
  priceDollars: 5.6,
  description:
    "A thank you card that says more... because there is chocolate inside!\n\nWhen a card is not enough and a gift is too much... enter Sweeter Cards, a new greeting-card-meets-chocolate-bar brand based in St. Louis. Each batch of chocolate is hand stirred in copper kettles and made with love to ensure every single Sweeter Card is full of deliciousness that will win the card-giving game. Shelf life is one year.\n\nRaising the (chocolate) bar on greeting cards!",
  tags: [],
  msrpDollars: 12.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:06.664Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
